import { Component, EventEmitter, Input, input, InputSignal, Output } from '@angular/core';
import { CustomBarChartComponent } from '@enginuity/analytics/organisms/custom-bar-chart/custom-bar-chart.component';
import { GroupChartTabs, Pagination } from '@services/analytics-services/core/group-chart.modals';
import { ErrorStateComponent } from '@enginuity/core/organisms/error-state/error-state.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custom-bar-chart-container',
  imports: [CustomBarChartComponent, CommonModule, ErrorStateComponent],
  templateUrl: './custom-bar-chart-container.component.html',
  styleUrl: './custom-bar-chart-container.component.scss',
})
export class CustomBarChartContainerComponent {
  @Output() tabChange = new EventEmitter<string>();
  @Output() pageChange = new EventEmitter<{ tabId: string; page: number; limit: number }>();
  @Input() headingTitle: string = '';
  @Input() subtitle: string = '';
  @Input() width: number | 'auto' = 'auto';
  @Input() height: number | 'auto' = 'auto';
  @Input() type: any = 'line';
  @Input() labels: any[] = [];
  @Input() DataLabel: string = '';
  @Input() title: string = '';
  @Input() multipleTitles: string[] = [];
  @Input() ValueTooltip: (metric: any) => string = () => '';

  @Input() legend: boolean = false;
  @Input() statsData: any[] = [];
  @Input() statsMap: { [tabId: string]: any[] } = {};
  @Input() badgeType: string = 'white';
  @Input() chartType: 'bar' | undefined;
  @Input() paginationData: Pagination = {
    limit: 10,
    next_page: null,
    total_pages: 1,
    previous_page: null,
    total_records: 0,
    current_page: 1,
  };
  @Input() showPagination: boolean = false;
  @Input() tabs: GroupChartTabs[] = [
    { id: 'overview', label: 'Overview' },
    { id: 'details', label: 'Details' },
    { id: 'analytics', label: 'Analytics' },
  ];
  @Input() defaultActiveTab: string = '';

  errorState: InputSignal<string | false> = input<string | false>(false);

  onTabChange(tabId: string) {
    this.defaultActiveTab = tabId; // Update the default active tab
    this.tabChange.emit(tabId);
  }

  onPageChange(event: { tabId: string; page: number; limit: number }) {
    this.pageChange.emit(event);
  }
}
